import { AbstractControl, ValidationErrors } from '@angular/forms';
import { IReference } from '@shared/interfaces/reference.interface';

export class DuplicateReferenceValidator {
  static DuplicateReference(
    field: string,
    references: IReference[]
  ): ValidationErrors | null {
    return (AC: AbstractControl) => {
      const value = AC && AC.get(field).value;
      AC.get(field).updateValueAndValidity({
        onlySelf: true,
        emitEvent: false
      });

      if (
        value &&
        references.find(
          (r: IReference) =>
            r.email.toLowerCase() === value.toLowerCase() || r.phone === value
        )
      ) {
        return AC.get(field).setErrors({
          DuplicateReference: true
        });
      }

      return null;
    };
  }
}
